import { Types } from './types'

const initialState = {
    dataPageSetting: {
        rows: [],
        paging: {}
    },
    dataPageHome: {}
}
const reducer = (state = initialState, action) => {
    let newState = Object.assign({}, state);
    switch (action.type) {
        case Types.SAVE_HOME_SETTING:
            return {
                ...newState,
                dataPageHome: action.payload
            }
        case Types.SAVE_LIST_PAGE_SETTING:
            return {
                ...newState,
                dataPageSetting: action.payload
            }
        
        default:
            return { ...newState }
    }
}
export default reducer
